import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import Table from '../../../components/Table/Table'
import { REPOSITORY } from '../../../api/repository/Repository'
import { formatStringNumber } from '../../../utils/formats/formats'
// const useHistoricalDetailData = (nDocument) => {}

const descriptionTableColumns = [
  { id: 'Rut', Header: 'RUT', type: 'dni' },
  { id: 'Nombre', Header: 'Nombre' },
  { id: 'Fecha', Header: 'Fecha', type: 'date' },
  { id: 'Monto', Header: 'Monto', type: 'currency' },
]
const MovementInfo = ({ label, data }) => {
  return (
    <HStack justifyContent="space-between" w="100%">
      <Box>
        <Text variant="subtitle2" color="#000000">
          {label}
        </Text>
      </Box>
      <Box>
        <Text variant="body2" color="#000000">
          {data}
        </Text>
      </Box>
    </HStack>
  )
}

const BillingDetails = ({
  data: {
    nOC,
    MontoBrutoOriginal,
    MontoDescuento,
    MontoNetoOriginal,
    Descripcion,
    FechaOC,
    MontoBrutoModificado,
    PorcentajeDescuento,
    MontoNetoModificado,
  },
}) => {
  return (
    <HStack w="100%" justifyContent="space-between" alignItems="flex-start">
      <VStack w="40%" alignItems="flex-start">
        <MovementInfo label={'N* Orden de compra:'} data={nOC} />
        <MovementInfo
          label={'Monto BRUTO original:'}
          data={formatStringNumber(MontoBrutoOriginal)}
        />
        <MovementInfo
          label={'Monto descuento:'}
          data={formatStringNumber(MontoDescuento)}
        />
        <MovementInfo
          label={'Monto NETO original:'}
          data={formatStringNumber(MontoNetoOriginal)}
        />
        <MovementInfo label={'Descripción:'} data={Descripcion} />
      </VStack>
      <VStack w="40%" justifyContent="flex-start">
        <MovementInfo label={'Fecha de emisión:'} data={FechaOC} />
        <MovementInfo
          label={'Monto BRUTO modificado:'}
          data={formatStringNumber(MontoBrutoModificado)}
        />
        <MovementInfo
          label={'Porcentaje descuento:'}
          data={`%${PorcentajeDescuento}`}
        />
        <MovementInfo
          label={'Monto NETO modificado'}
          data={formatStringNumber(MontoNetoModificado)}
        />
      </VStack>
    </HStack>
  )
}

BillingDetails.propTypes = {
  nDocument: PropTypes.string,
  data: PropTypes.object,
}

MovementInfo.propTypes = {
  data: PropTypes.string,
  label: PropTypes.string,
}
export default function OCDetail({ isOpen, onClose, nOC }) {
  const { colors } = useTheme()
  const [ocDetail, setOcDetail] = useState(null)
  const getHistoricalDetail = async () => {
    await REPOSITORY.wsEmpresa.company.getOCById(nOC).then((res) => {
      setOcDetail(res.data)
    })
  }
  useEffect(() => {
    if (isOpen) {
      getHistoricalDetail()
    }

    return () => {
      if (!isOpen) {
        setOcDetail(null)
      }
    }
  }, [isOpen])

  return (
    <>
      <Modal size="3xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            bgColor={colors.primary.base}
            borderRadius="5px 5px 0px 0px"
          >
            <Text
              textAlign="center"
              color={colors.gray['50-0']}
              variant="subtitle2"
            >
              Detalle movimiento OC
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <VStack
              w="100%"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <VStack
                p="16px"
                w="100%"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <BillingDetails data={ocDetail?.InfoCabeceraOC || {}} />
                <Table
                  data={ocDetail?.lDetalleMovOC || []}
                  columns={descriptionTableColumns}
                />
              </VStack>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Center w="100%">
              <Button variant="gray800" w="116px" onClick={onClose}>
                Cerrar
              </Button>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

OCDetail.propTypes = {
  isOpen: PropTypes.bool,
  nOC: PropTypes.string,
  onClose: PropTypes.func,
}
